import Vue from 'vue';
Vue.config.silent = true;
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import Messages from './pages/Messages/Messages';
import MessageDetails from "./pages/Messages/MessageDetails";
import HopeIndex from "./pages/HopeIndex";
import AppWizard from "./pages/AppWizard/Index";

export default new VueRouter({
    routes: [
        {
            path: '/',
            component: HopeIndex,
            name: 'dashboard',
        },
        {
            path: '/inbox',
            component: Messages,
            name: 'inbox',
        },
        {
            path: '/messages/:id',
            component: MessageDetails,
            props: true,
            name: 'messageDetails',
        },

        // Application Routes
        {
            path: '/application/:id',
            props: true,
            component: AppWizard,
            name: 'appWizard'

        },
    ],
})
